// third-party
// type
import { NavItemType } from 'types/menu';
import { Typography } from '@mui/material';
import HomeIcon from 'assets/svgs/HomeIcon';
import SettingsIcon from 'assets/svgs/SettingsIcon';
import DeliveryIcon from 'assets/svgs/DeliveryIcon';
import { SectionStatus, Role } from 'types';
import BankIcon from 'assets/svgs/BankIcon';
import QrCodeIcon from 'assets/svgs/QrCodeIcon';
import ReportsIcon from 'assets/svgs/ReportsIcon';
import AnalyticsIcon from 'assets/svgs/AnalyticsIcon';

const filterMenuItemsByRole = (role: string, deliverySectionStatus: SectionStatus, analyticsSectionStatus: SectionStatus, items: NavItemType[]) => {
  return items.filter(item => {
    if (role === Role.ADMIN || role === Role.SUPER_ADMIN) {
      if(item.id === "delivery" && SectionStatus.INACTIVE === deliverySectionStatus) {
        return false;
      }
      if(item.id === "analytics" && SectionStatus.INACTIVE === analyticsSectionStatus) {
        return false;
      }
      return true; 
    }
    if (role === Role.SUPPORT) {
      return item.id !== 'settings' && item.id !== 'delivery' && item.id !== 'reports' && item.id !== 'analytics'; 
    }
    return true;
  });
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const getApplicationsMenu = (role: string, deliverySectionStatus: SectionStatus, analyticsSectionStatus: SectionStatus): NavItemType => {
  const applications: NavItemType = {
    id: 'group-applications',
    title: <Typography id="applications">Applications</Typography>,
    type: 'group',
    children: filterMenuItemsByRole(role, deliverySectionStatus, analyticsSectionStatus, [
      {
        id: 'home',
        title: <Typography id="Home">Accueil</Typography>,
        url: '/home/',
        type: 'item',
        icon: HomeIcon,
        processUrl: '/home/',
      },
      {
        id: 'account',
        title: <Typography id="Account">Compte</Typography>,
        url: '/account/',
        type: 'item',
        icon: BankIcon,
        processUrl: '/account/',
      },
      {
        id: 'delivery',
        title: <Typography id="delivery">Livreurs</Typography>,
        type: 'item',
        url: '/delivery/',
        icon: DeliveryIcon,
        processUrl: '/delivery/',
      },
      {
        id: 'reports',
        title: <Typography id="reports">Historique</Typography>,
        type: 'item',
        url: '/reports/',
        icon: ReportsIcon,
        processUrl: '/reports/',
      },
      {
        id: 'analytics',
        title: <Typography id="analytics">Analytique</Typography>,
        type: 'item',
        url: '/analytics/',
        icon: AnalyticsIcon,
        processUrl: '/analytics/',
      },
      {
        id: 'qrcode',
        title: <Typography id="QrCode">Code QR</Typography>,
        url: '/qrcode/',
        type: 'item',
        icon: QrCodeIcon,
        processUrl: '/qrcode/',
      },
      {
        id: 'settings',
        title: <Typography id="Settings">Paramètres</Typography>,
        type: 'item',
        url: '/settings/',
        icon: SettingsIcon,
        processUrl: '/settings/',
      },
    ]),
  };

  return applications;
};

export default getApplicationsMenu;
